(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1176,9540],{

/***/ 9540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var marked__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8692);
/* harmony import */ var _helpers_sanitizationHelper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8948);






const Typography = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.memo(function Typography(param) {
    let { className: classNameProp , component: componentProp , children , content , ...other } = param;
    const className = classnames__WEBPACK_IMPORTED_MODULE_2___default()(classNameProp);
    const Component = componentProp || "p";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Component, {
        className: className,
        ...other,
        children: [
            content && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: (0,marked__WEBPACK_IMPORTED_MODULE_3__/* .marked */ .TU)((0,_helpers_sanitizationHelper__WEBPACK_IMPORTED_MODULE_4__/* .sanitize */ .N)(content))
                }
            }),
            children
        ]
    });
});
Typography.propTypes = {
    /**
   * The content of the component.
   */ /**
   * @ignore
   */ className: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().any),
    /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * By default, it maps the variant to a good default headline component.
   */ component: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
        (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func)
    ]),
    content: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().any)
};
Typography.defaultProps = {
    className: "",
    component: "p"
};
/* harmony default export */ __webpack_exports__["default"] = (Typography);


/***/ }),

/***/ 8948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ sanitize; }
/* harmony export */ });
let sanitizeHtml = __webpack_require__(4791);
const config = {
    allowedTags: [
        "br",
        "span",
        "div",
        "sup",
        "b",
        "h1",
        "h2",
        "h3",
        "a"
    ],
    allowedAttributes: {
        "span": [
            "class",
            "id"
        ],
        "div": [
            "class"
        ],
        "a": [
            "href",
            "class",
            "data-action-detail",
            "target"
        ],
        "br": [
            "class"
        ],
        "h2": [
            "id"
        ]
    }
};
const allowedNothingConfig = {
    allowedTags: [],
    allowedAttributes: []
};
const sanitize = (html, strict)=>{
    const sanitizeConfig = strict ? allowedNothingConfig : config;
    return sanitizeHtml(html, sanitizeConfig);
};


/***/ }),

/***/ 8577:
/***/ (function() {

/* (ignored) */

/***/ })

}]);